// App.js
import React, { useState, useEffect, useRef } from 'react';
import './App.css';
import emailjs from 'emailjs-com';

// EmailJS'i başlat
emailjs.init("43ApygFAwoZ3CoYWdwbRZ"); // EmailJS User ID'nizi buraya ekleyin

function App() {
  const [hearts, setHearts] = useState([]);
  const [mouseTrailHearts, setMouseTrailHearts] = useState([]);
  const [explodeHearts, setExplodeHearts] = useState([]);
  const [bigHeartFormed, setBigHeartFormed] = useState(false);
  const [showButton, setShowButton] = useState(false);
  const [lastSeen, setLastSeen] = useState("");
  const [showMessage, setShowMessage] = useState(false);
  const [userMessage, setUserMessage] = useState("");
  const [messageSubmitted, setMessageSubmitted] = useState(false);
  const [showPhotoAlbum, setShowPhotoAlbum] = useState(false);
  const [photos, setPhotos] = useState([
    { id: 1, url: '/assets/sertaperenerkonser.jpeg', caption: 'Sertap Erener Konseri' },
    { id: 2, url: '/assets/sporda.jpeg', caption: 'Spor Yaparken' },
    { id: 3, url: '/assets/aksam.jpeg', caption: 'Akşam Buluşması' },
    { id: 4, url: '/assets/yilbasisabahi.jpeg', caption: 'Yılbaşı Sabahı' },
    { id: 5, url: '/assets/ikea.jpeg', caption: 'IKEA Gezintisi' },
    { id: 6, url: '/assets/muzikparti.jpeg', caption: 'Müzik Partisi' },
    { id: 7, url: '/assets/tekathon.jpeg', caption: 'Tekathon Etkinliği' },
    { id: 8, url: '/assets/karaokegecesi.jpeg', caption: 'Karaoke Gecesi' },
    { id: 9, url: '/assets/yilbasi.jpeg', caption: 'Yılbaşı Kutlaması' },
  ]);
  const [currentPhotoIndex, setCurrentPhotoIndex] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [offsetX, setOffsetX] = useState(0);
  const containerRef = useRef(null);
  const animationFrameRef = useRef(null);
  const photoContainerRef = useRef(null);
  const [password, setPassword] = useState("");
  const [showLove, setShowLove] = useState(false);
  
  // Renk paleti - mavi ve mor tonları (özlem teması için)
  const colors = {
    background: 'linear-gradient(135deg, #3498db 0%, #9b59b6 100%)',
    hearts: [
      '#3498db', // Mavi
      '#4b7bec', // Parlak mavi
      '#5352ed', // İndigo
      '#8c7ae6', // Mor
      '#9b59b6', // Mor
      '#6c5ce7', // Koyu mavi
      '#0984e3', // Elektrik mavisi
      '#74b9ff', // Açık mavi
      '#a29bfe', // Lavanta
      '#273c75', // Koyu mavi
      '#192a56'  // Gece mavisi
    ]
  };
  
  // Kalpler için rastgele renkler
  const getRandomColor = () => {
    return colors.hearts[Math.floor(Math.random() * colors.hearts.length)];
  };
  
  // Son görülme zamanını ayarla - gerçek zamana
  useEffect(() => {
    // Şu anki zamanı al
    const now = new Date();
    
    const hours = now.getHours().toString().padStart(2, '0');
    const minutes = now.getMinutes().toString().padStart(2, '0');
    
    setLastSeen(`Son giriş: ${hours}:${minutes}`);
  }, []);
  
  // Kalp animasyonunu başlat
  useEffect(() => {
    if (!containerRef.current) return;
    
    // Var olan animasyonları temizle
    if (animationFrameRef.current) {
      cancelAnimationFrame(animationFrameRef.current);
    }
    
    const width = containerRef.current.offsetWidth;
    const height = containerRef.current.offsetHeight;
    
    // Ekranın farklı kenarlarından başlayan kalpler oluştur
    const initialHearts = [];
    const isMobile = window.innerWidth < 600;
    const heartCount = isMobile ? 40 : 100;
    
    for (let i = 0; i < heartCount; i++) {
      // Hangi kenardan başlayacağına karar ver
      const edge = Math.floor(Math.random() * 4);
      let x, y;
      
      if (edge === 0) { // Üst
        x = Math.random() * width;
        y = -20;
      } else if (edge === 1) { // Sağ
        x = width + 20;
        y = Math.random() * height;
      } else if (edge === 2) { // Alt
        x = Math.random() * width;
        y = height + 20;
      } else { // Sol
        x = -20;
        y = Math.random() * height;
      }
      
      initialHearts.push({
        id: `heart-${i}`,
        x: x,
        y: y,
        size: Math.random() * 12 + 8, // Biraz daha küçük kalpler
        color: getRandomColor(),
        targetX: 0, // Animasyon sırasında ayarlanacak
        targetY: 0, // Animasyon sırasında ayarlanacak
        speed: Math.random() * 0.3 + 0.05,
        rotation: Math.random() * 360,
        wobble: Math.random() * 2 * Math.PI,
        wobbleSpeed: Math.random() * 0.05 + 0.02,
        scale: 1,
        opacity: Math.random() * 0.5 + 0.5
      });
    }
    
    setHearts(initialHearts);
    
    // 1 saniye sonra animasyonu başlat
    setTimeout(() => {
      animateHeartsToFormBigHeart();
    }, 1000);
    
    // Animasyon tamamlandıktan sonra butonu ve mesajı göster
    setTimeout(() => {
      setShowButton(true);
      setShowMessage(true);
    }, 6000);
    
    return () => {
      if (animationFrameRef.current) {
        cancelAnimationFrame(animationFrameRef.current);
      }
    };
  }, []);
  
  // Kalpleri büyük bir kalp şekli oluşturacak şekilde hizala
  const animateHeartsToFormBigHeart = () => {
    if (!containerRef.current) return;
    
    const width = containerRef.current.offsetWidth;
    const height = containerRef.current.offsetHeight; // Mesaj gönderme işlemi
    
    
    // Ekranın merkezi
    const centerX = width / 2;
    const centerY = height / 2;
    
    // Ekran boyutuna göre kalp boyutu
    const heartSize = Math.min(width, height) * 0.35;
    
    // Tüm kalpler için kalp şekli pozisyonlarını hesapla
    setHearts(prevHearts => {
      return prevHearts.map((heart, i) => {
        // Kalp parametrik denklemi için açı
        const t = (i / prevHearts.length) * 2 * Math.PI;
        // Kalp şekli koordinatları - kalp şekli için parametrik denklem
        const x = 16 * Math.pow(Math.sin(t), 3);
        const y = -(13 * Math.cos(t) - 5 * Math.cos(2 * t) - 2 * Math.cos(3 * t) - Math.cos(4 * t));
        
        // Merkeze göre ölçekle ve konumlandır
        const targetX = centerX + (x * heartSize / 30);
        const targetY = centerY + (y * heartSize / 30);
        
        return {
          ...heart,
          targetX: targetX,
          targetY: targetY
        };
      });
    });
    
    let frame = 0;
    const animate = () => {
      frame++;
      if (frame % 2 === 0) {
        let allReached = true;
        
        setHearts(prevHearts => {
          return prevHearts.map(heart => {
            // Hedefe doğru vektör
            const dx = heart.targetX - heart.x;
            const dy = heart.targetY - heart.y;
            const distance = Math.sqrt(dx * dx + dy * dy);
            
            // Kalp hedefe ulaştı mı kontrol et
            if (distance < 1) {
              return {
                ...heart,
                x: heart.targetX,
                y: heart.targetY
              };
            }
            
            allReached = false;
            
            // Kalbi hedefe doğru hareket ettir
            const angle = Math.atan2(dy, dx);
            // Daha yavaş hareket için hız katsayısını azalt
            const vx = Math.cos(angle) * heart.speed * distance * 0.08;
            const vy = Math.sin(angle) * heart.speed * distance * 0.08;
            
            // Biraz sallanma ekle
            heart.wobble += heart.wobbleSpeed;
            const wobbleX = Math.sin(heart.wobble) * 0.7; // Daha belirgin sallanma
            const wobbleY = Math.cos(heart.wobble) * 0.7;
            
            return {
              ...heart,
              x: heart.x + vx + wobbleX,
              y: heart.y + vy + wobbleY,
              rotation: heart.rotation + 1.5 // Daha yavaş dönme
            };
          });
        });
        
        if (allReached) {
          setBigHeartFormed(true);
          // Oluşan kalbi titreşimli hale getir
          pulseHeartAnimation();
          return;
        }
      }
      requestAnimationFrame(animate);
    };
    
    animationFrameRef.current = requestAnimationFrame(animate);
  };
  
  // Kalp oluştuktan sonra titreşim ve özlem efekti ekle
  const pulseHeartAnimation = () => {
    const animate = () => {
      setHearts(prevHearts => {
        return prevHearts.map(heart => {
          heart.wobble += heart.wobbleSpeed * 0.7; // Daha yavaş sallanma
          
          // Daha yavaş ve buğulu atış efekti
          const pulseScale = 1 + Math.sin(Date.now() / 2000) * 0.1;
          
          // Hedef pozisyon etrafında küçük daireler çizme
          const radius = 1.5; // Daha küçük hareket
          const circleX = Math.cos(heart.wobble) * radius;
          const circleY = Math.sin(heart.wobble) * radius;
          
          return {
            ...heart,
            x: heart.targetX + circleX,
            y: heart.targetY + circleY,
            scale: pulseScale,
            opacity: 0.7 + Math.sin(Date.now() / 800 + heart.id.length) * 0.3
          };
        });
      });
      
      requestAnimationFrame(animate);
    };
    
    animationFrameRef.current = requestAnimationFrame(animate);
  };
  
  // Fare takibi için kalp izi
  useEffect(() => {
    const handleMouseMove = (e) => {
      if (!containerRef.current) return;
      
      const rect = containerRef.current.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      
      // İz kalpleri ekle
      if (Math.random() > 0.7) {
        const newHeart = {
          id: `trail-${Date.now()}-${Math.random()}`,
          x: x,
          y: y,
          size: Math.random() * 12 + 5,
          color: getRandomColor(),
          vx: (Math.random() - 0.5) * 2,
          vy: (Math.random() - 0.5) * 2 - 1, // Hafif yukarı yönlü
          rotation: Math.random() * 360,
          opacity: 1,
          life: 1
        };
        
        setMouseTrailHearts(prev => [...prev, newHeart]);
      }
    };
    
    const animateTrailHearts = () => {
      setMouseTrailHearts(prev => 
        prev
          .map(heart => ({
            ...heart,
            x: heart.x + heart.vx,
            y: heart.y + heart.vy,
            vy: heart.vy + 0.03, // Yerçekimi ekle
            rotation: heart.rotation + 2,
            opacity: heart.opacity - 0.02,
            life: heart.life - 0.02
          }))
          .filter(heart => heart.life > 0)
      );
      
      requestAnimationFrame(animateTrailHearts);
    };
    
    window.addEventListener('mousemove', handleMouseMove);
    const animationId = requestAnimationFrame(animateTrailHearts);
    
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      cancelAnimationFrame(animationId);
    };
  }, []);
  
  // Tıklama için patlama efekti
  const handleClick = (e) => {
    if (!containerRef.current) return;
    
    const rect = containerRef.current.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    
    // Patlama için kalpler oluştur
    const newHearts = [];
    for (let i = 0; i < 30; i++) {
      const angle = Math.random() * Math.PI * 2;
      const speed = Math.random() * 5 + 2;
      
      newHearts.push({
        id: `explode-${Date.now()}-${i}`,
        x: x,
        y: y,
        size: Math.random() * 12 + 5,
        color: getRandomColor(),
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed,
        rotation: Math.random() * 360,
        rotationSpeed: Math.random() * 10 - 5,
        opacity: 1,
        life: 1
      });
    }
    
    setExplodeHearts(prev => [...prev, ...newHearts]);
  };
  
  // Patlayan kalpleri animate et
  useEffect(() => {
    const animateExplosion = () => {
      setExplodeHearts(prev => 
        prev
          .map(heart => ({
            ...heart,
            x: heart.x + heart.vx,
            y: heart.y + heart.vy,
            vy: heart.vy + 0.1, // Yerçekimi ekle
            vx: heart.vx * 0.98, // Hava direnci ekle
            rotation: heart.rotation + heart.rotationSpeed,
            opacity: heart.opacity - 0.02,
            life: heart.life - 0.02
          }))
          .filter(heart => heart.life > 0)
      );
      
      requestAnimationFrame(animateExplosion);
    };
    
    const animationId = requestAnimationFrame(animateExplosion);
    return () => cancelAnimationFrame(animationId);
  }, []);
  
  // Sabit düşen kalpler için
  useEffect(() => {
    let fallingHearts = [];
    
    const createFallingHeart = () => {
      if (!containerRef.current) return;
      
      const width = containerRef.current.offsetWidth;
      
      const newHeart = {
        id: `falling-${Date.now()}-${Math.random()}`,
        x: Math.random() * width,
        y: -50,
        size: Math.random() * 15 + 10,
        color: getRandomColor(),
        speed: Math.random() * 2 + 1,
        rotation: Math.random() * 360,
        rotationSpeed: Math.random() * 4 - 2,
        wobble: Math.random() * 2 * Math.PI,
        wobbleSpeed: Math.random() * 0.02 + 0.01,
        opacity: Math.random() * 0.5 + 0.5
      };
      
      fallingHearts.push(newHeart);
    };
    
    // Belirli aralıklarla düşen kalpler oluştur
    const heartInterval = setInterval(() => {
      createFallingHeart();
    }, 1000);
    
    // Düşen kalpleri animasyonla hareket ettir
    const animateFallingHearts = () => {
      if (!containerRef.current) return;
      
      const height = containerRef.current.offsetHeight;
      
      fallingHearts = fallingHearts.filter(heart => heart.y < height + 50);
      
      fallingHearts.forEach(heart => {
        heart.y += heart.speed;
        heart.rotation += heart.rotationSpeed;
        heart.wobble += heart.wobbleSpeed;
        heart.x += Math.sin(heart.wobble) * 1;
      });
      
      // DOM'a yansıtmak için kalpleri state'e aktar
      setExplodeHearts(prev => {
        const existingIds = new Set(prev.map(h => h.id));
        const newHearts = fallingHearts.filter(h => !existingIds.has(h.id));
        
        return [...prev.filter(h => h.life > 0), ...newHearts.map(h => ({
          ...h,
          vx: 0,
          vy: h.speed,
          life: 1
        }))];
      });
      
      requestAnimationFrame(animateFallingHearts);
    };
    
    const animationId = requestAnimationFrame(animateFallingHearts);
    
    return () => {
      clearInterval(heartInterval);
      cancelAnimationFrame(animationId);
    };
  }, []);
  
  // Kalp animasyonunu sıfırla
  const resetHeartAnimation = () => {
    // Tüm mevcut kalpleri temizle
    setHearts([]);
    setBigHeartFormed(false);
    setShowButton(false);
    setShowMessage(false);
    
    // Mevcut animasyonu iptal et
    if (animationFrameRef.current) {
      cancelAnimationFrame(animationFrameRef.current);
    }
    
    // Efekti yeniden başlat
    setTimeout(() => {
      if (!containerRef.current) return;
      
      const width = containerRef.current.offsetWidth;
      const height = containerRef.current.offsetHeight;
      
      // Yeni kalpler oluştur
      const newHearts = [];
      const heartCount = 60;
      
      for (let i = 0; i < heartCount; i++) {
        // Kalpleri ekran kenarlarında rastgele konumlandır
        const edge = Math.floor(Math.random() * 4);
        let x, y;
        
        if (edge === 0) { // Üst
          x = Math.random() * width;
          y = -20;
        } else if (edge === 1) { // Sağ
          x = width + 20;
          y = Math.random() * height;
        } else if (edge === 2) { // Alt
          x = Math.random() * width;
          y = height + 20;
        } else { // Sol
          x = -20;
          y = Math.random() * height;
        }
        
        newHearts.push({
          id: `heart-${Date.now()}-${i}`,
          x: x,
          y: y,
          size: Math.random() * 12 + 8,
          color: getRandomColor(),
          targetX: 0,
          targetY: 0,
          speed: Math.random() * 0.3 + 0.05,
          rotation: Math.random() * 360,
          wobble: Math.random() * 2 * Math.PI,
          wobbleSpeed: Math.random() * 0.05 + 0.02,
          scale: 1,
          opacity: Math.random() * 0.5 + 0.5
        });
      }
      
      setHearts(newHearts);
      
      // Yeni animasyonu başlat
      setTimeout(() => {
        animateHeartsToFormBigHeart();
      }, 500);
      
      // Butonu ve mesajı tekrar göster
      setTimeout(() => {
        setShowButton(true);
        setShowMessage(true);
      }, 6000);
    }, 300);
  };

 

  // Mesaj ikonu bileşeni
  const MessageIcon = () => (
    <svg className="message-icon" width="40" height="40" viewBox="0 0 24 24" fill="#fff">
      <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 2v.5l-8 5-8-5V6h16zM4 18V9l8 5 8-5v9H4z" />
    </svg>
  );

  // Kalp SVG bileşeni - gerçek kalp şekillerini oluşturmak için kullanılır
  const HeartSVG = ({ color, size, rotation, opacity, scale }) => (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill={color}
      style={{ 
        transform: `rotate(${rotation}deg) scale(${scale || 1})`,
        opacity: opacity,
        filter: `drop-shadow(0 0 2px ${color})`
      }}
    >
      <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
    </svg>
  );

  // Fotoğraf albumünü göster
  const togglePhotoAlbum = (e) => {
    e.stopPropagation();
    setShowPhotoAlbum(!showPhotoAlbum);
  };

  // Fotoğraf kaydırma işlemleri
  const handleTouchStart = (e) => {
    setIsDragging(true);
    setStartX(e.touches[0].clientX);
  };

  const handleMouseDown = (e) => {
    setIsDragging(true);
    setStartX(e.clientX);
  };

  const handleTouchMove = (e) => {
    if (!isDragging) return;
    const currentX = e.touches[0].clientX;
    const diff = currentX - startX;
    setOffsetX(diff);
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    const currentX = e.clientX;
    const diff = currentX - startX;
    setOffsetX(diff);
  };

  const handleTouchEnd = () => {
    if (!isDragging) return;
    completeSwipe();
  };

  const handleMouseUp = () => {
    if (!isDragging) return;
    completeSwipe();
  };

  const completeSwipe = () => {
    const threshold = 100; // minumum swipe distance
    
    if (offsetX > threshold) {
      // Sağa kaydırma
      if (currentPhotoIndex > 0) {
        setCurrentPhotoIndex(currentPhotoIndex - 1);
      }
    } else if (offsetX < -threshold) {
      // Sola kaydırma
      if (currentPhotoIndex < photos.length - 1) {
        setCurrentPhotoIndex(currentPhotoIndex + 1);
      }
    }
    
    setIsDragging(false);
    setOffsetX(0);
  };

  // Fotoğraf yükleme fonksiyonu (fetch ile)
  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);
    formData.append("upload_preset", "anilar"); // kendi unsigned preset adın

    const res = await fetch(
      "https://api.cloudinary.com/v1_1/dtxf5ibcl/image/upload",
      {
        method: "POST",
        body: formData,
      }
    );
    const data = await res.json();

    // data.public_id ve data.secure_url döner
    // public_id ile Cloudinary React SDK'da gösterim yapabilirsin
    setPhotos(prev => [...prev, { public_id: data.public_id, url: data.secure_url }]);
  };

  // Fotoğraf silme işlemi
  const deletePhoto = (e, photoId) => {
    e.stopPropagation();
    if (window.confirm('Bu anıyı silmek istediğinizden emin misiniz?')) {
      const newPhotos = photos.filter(photo => photo.id !== photoId);
      setPhotos(newPhotos);
      
      // Eğer silinen fotoğraf şu anki görüntülenen ise
      if (currentPhotoIndex >= newPhotos.length) {
        setCurrentPhotoIndex(Math.max(0, newPhotos.length - 1));
      }
    }
  };

  const handlePasswordSubmit = (e) => {
    e.preventDefault();
    if (password === "askim123") { // Şifreni buraya yaz
      setShowLove(true);
    } else {
      setShowLove(false);
      alert("Şifre yanlış!");
    }
    setPassword("");
  };

  return (
    <div 
      ref={containerRef}
      className="heart-app"
      onClick={handleClick}
      style={{ background: colors.background }}
    >
      {/* Başlık */}
      <div className={`title ${bigHeartFormed ? 'show' : ''}`}>
        <h1>Seni Çok Özledim</h1>
        <p className={`subtitle ${bigHeartFormed ? 'show' : ''}`}>Her gün, her an...</p>
      </div>
      
      {/* Son görülme bilgisi */}
      <div className={`last-seen ${bigHeartFormed ? 'show' : ''}`}>
        {lastSeen}
      </div>

      {/* Spotify embed */}
      <div style={{ display: 'flex', justifyContent: 'center', margin: '2rem 0' }}>
        <iframe
          title="Spotify Track"
          src="https://open.spotify.com/embed/track/1jhnbRVTmRJjnRhabesRqn?utm_source=generator&theme=0"
          width="100%"
          height="80"
          frameBorder="0"
          allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
          allowFullScreen
          loading="lazy"
          style={{ borderRadius: '12px' }}
        />
      </div>

      {/* Kalp parçacıkları - büyük kalbi oluşturanlar */}
      {hearts.map(heart => (
        <div
          key={heart.id}
          className="heart-particle"
          style={{
            left: `${heart.x - heart.size/2}px`,
            top: `${heart.y - heart.size/2}px`,
          }}
        >
          <HeartSVG 
            color={heart.color}
            size={heart.size}
            rotation={heart.rotation}
            opacity={heart.opacity}
            scale={heart.scale}
          />
        </div>
      ))}
      
      {/* Fare izi kalpleri */}
      {mouseTrailHearts.map(heart => (
        <div
          key={heart.id}
          className="heart-particle"
          style={{
            left: `${heart.x - heart.size/2}px`,
            top: `${heart.y - heart.size/2}px`,
          }}
        >
          <HeartSVG 
            color={heart.color}
            size={heart.size}
            rotation={heart.rotation}
            opacity={heart.opacity}
          />
        </div>
      ))}
      
      {/* Patlama kalpleri ve düşen kalpler */}
      {explodeHearts.map(heart => (
        <div
          key={heart.id}
          className="heart-particle"
          style={{
            left: `${heart.x - heart.size/2}px`,
            top: `${heart.y - heart.size/2}px`,
          }}
        >
          <HeartSVG 
            color={heart.color}
            size={heart.size}
            rotation={heart.rotation}
            opacity={heart.opacity}
          />
        </div>
      ))}
      
      {/* Mesaj formu */}
      {showMessage && (
        <div className={`floating-message ${showMessage ? 'show' : ''}`} onClick={(e) => e.stopPropagation()}>
          <MessageIcon />
          <div className="message-form">
            {messageSubmitted ? (
              <div className="message-success">Mesajın gönderildi ❤️</div>
            ) : (
              <form className="password-form" onSubmit={handlePasswordSubmit}>
        <input
          type="password"
          placeholder="Şifreyi gir..."
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <button type="submit" className="fancy-btn">Gönder</button>
      </form>
            )}
          </div>
        </div>
      )}
      
      {/* Buton */}
      {showButton && (
        <div className="button-container">
          <button
            onClick={(e) => {
              e.stopPropagation();
              resetHeartAnimation();
            }}
            className={`heart-button ${showButton ? 'show' : ''}`}
          >
            Kalp Yağmuru
          </button>
          
          <button
            onClick={togglePhotoAlbum}
            className={`album-button ${showButton ? 'show' : ''}`}
          >
            Anı Defteri
          </button>
        </div>
      )}
      
      {/* Fotoğraf Albümü */}
      {showPhotoAlbum && (
        <div 
          className="photo-album"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="album-header">
            <h2>Anılarımız</h2>
            <label className="upload-btn">
              <input 
                type="file" 
                accept="image/*" 
                onChange={handleFileUpload}
                style={{ display: 'none' }}
              />
              Yeni Anı Ekle
            </label>
            <button className="close-btn" onClick={togglePhotoAlbum}>✕</button>
          </div>
          
          <div 
  className="photo-container"
  ref={photoContainerRef}
  onTouchStart={handleTouchStart}
  onTouchMove={handleTouchMove}
  onTouchEnd={handleTouchEnd}
  onMouseDown={handleMouseDown}
  onMouseMove={handleMouseMove}
  onMouseUp={handleMouseUp}
  onMouseLeave={handleMouseUp}
>
  {/* Sol Ok */}
  <button
    className="photo-arrow left"
    onClick={() => setCurrentPhotoIndex((i) => Math.max(0, i - 1))}
    disabled={currentPhotoIndex === 0}
    aria-label="Önceki fotoğraf"
  >
    &#8592;
  </button>

  {/* Fotoğraf Kartları */}
  {photos.map((photo, index) => (
    <div 
      key={photo.id}
      className={`photo-card ${index === currentPhotoIndex ? 'active' : ''}`}
      style={{
        transform: `translateX(${index === currentPhotoIndex ? offsetX : 0}px) 
                    scale(${index === currentPhotoIndex ? 1 : 0.8}) 
                    translateX(${(index - currentPhotoIndex) * 120}%)`
      }}
    >
      <img src={photo.url} alt="Anı" />
      <div className="photo-caption">{photo.caption}</div>
      <button 
        className="delete-photo-btn"
        onClick={(e) => deletePhoto(e, photo.id)}
        title="Bu anıyı sil"
      >
        ✕
      </button>
    </div>
  ))}

  {/* Sağ Ok */}
  <button
    className="photo-arrow right"
    onClick={() => setCurrentPhotoIndex((i) => Math.min(photos.length - 1, i + 1))}
    disabled={currentPhotoIndex === photos.length - 1}
    aria-label="Sonraki fotoğraf"
  >
    &#8594;
  </button>
</div>
          
          <div className="photo-indicators">
            {photos.map((_, index) => (
              <div 
                key={index} 
                className={`indicator ${index === currentPhotoIndex ? 'active' : ''}`}
                onClick={() => setCurrentPhotoIndex(index)}
              />
            ))}
          </div>
        </div>
      )}
      {showLove && (
        <div className="love-modal-overlay">
          <div className="love-modal">
            <span>❤️ Seni Çok Seviyorum ❤️</span>
            <button className="close-modal-btn" onClick={() => setShowLove(false)}>Kapat</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;